var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r1_iframe_embed",attrs:{"id":`iframe.wrapper.${_vm.keyId}`}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"iframe_loader",attrs:{"color":"primary","indeterminate":"","size":"35","width":"5"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }